<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50">
    <div class="bg-white shadow-md rounded-lg overflow-hidden flex flex-col md:flex-row w-full max-w-5xl">
      <!-- Left Section -->
      <div class="w-full md:w-1/2 p-8">
        <PhotoDiagramLogo class="mb-4" />

        <h2 class="text-3xl font-semibold mb-4">Sign up now</h2>
        <p class="text-sm text-gray-500 mb-6">Create a free account</p>
        
        <GoogleSignInButton text="Sign up with Google" /> 

        <div class="flex items-center my-4">
          <div class="flex-grow border-t border-gray-300"></div>
          <span class="px-4 text-gray-500 text-sm">or</span>
          <div class="flex-grow border-t border-gray-300"></div>
        </div>

        <form @submit.prevent="signup">
          <input
            type="email"
            placeholder="Email address"
            v-model="email"
            class="w-full border border-gray-300 rounded-lg py-2 px-4 mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          >
          <input
            type="password"
            placeholder="Password"
            v-model="password"
            class="w-full border border-gray-300 rounded-lg py-2 px-4 mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          >
          <input
            type="password"
            placeholder="Repeat password"
            v-model="repeatPassword"
            class="w-full border border-gray-300 rounded-lg py-2 px-4 mb-6 focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          >
          <p v-if="errorMessage" class="text-red-500 mb-4">{{ errorMessage }}</p>
          <button
            type="submit"
            class="w-full bg-black text-white rounded-lg py-2 px-4 hover:bg-gray-800"
          >
            Sign up
          </button>
        </form>

        <p class="text-sm text-gray-500 mt-4 text-center">
          Already have an account? <RouterLink :to="{name: 'sign-in'}" class="text-blue-500 hover:underline">Sign in</RouterLink>
        </p>

        <p class="text-sm text-gray-500 mt-4 text-center">
          <a href="https://www.freeprivacypolicy.com/live/dde47b4d-37fe-4846-89b1-7fc605bdedcf" target="_blank">Privacy Policy</a>
        </p>
      </div>

      <!-- Right Section -->
      <div
        class="hidden md:block w-full md:w-1/2 bg-cover bg-center"
        :style="{'background-image': 'url(' + require('@/assets/hero.jpg') + ')'}"
      >
        <div class="h-full flex flex-col justify-center p-8 bg-black bg-opacity-40 text-white">
          <h3 class="text-2xl font-semibold mb-4">Bring your ideas to life.</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  createUserWithEmailAndPassword,
} from "firebase/auth";
import { auth } from "@/firebase";
import { useMainStore } from "@/store";
import { useRouter } from 'vue-router';

import PhotoDiagramLogo from "@/components/PhotoDiagramLogo.vue";
import GoogleSignInButton from "@/components/GoogleSignInButton.vue";
export default {
  name: "SignupPage",
  components: {
    PhotoDiagramLogo,
    GoogleSignInButton,
  },
  data() {
    return {
      email: "",
      password: "",
      repeatPassword: "",
      errorMessage: "", // Add error message data property
    };
  },
  watch: {
    email() {
      this.errorMessage = "";
    },
    password() {
      this.errorMessage = "";
    },
    repeatPassword() {
      this.errorMessage = "";
    },
  },
  setup() {
    const store = useMainStore();
    const router = useRouter();
    return { store, router };
  },
  methods: {
    signup() {
      if (this.password !== this.repeatPassword) {
        this.errorMessage = "Passwords do not match."; // Set error message
        return;
      }
      createUserWithEmailAndPassword(auth, this.email, this.password)
        .then((userCredential) => {
          this.store.setUser(userCredential.user);
          this.router.push({ name: 'home' });
        })
        .catch((error) => {
          if (error.code === 'auth/email-already-in-use') {
            this.errorMessage = "This email is already in use."; // Specific message for email already in use
          } else {
            this.errorMessage = error.message; // Set error message
          }
        });
    },
  },
};
</script>

<style>
body {
  font-family: Arial, sans-serif;
}
</style>
